import axios from 'axios';
import store from '@/store'
import router from '@/router';
import Vue from "vue";
import {COUNTRIES_SNG, SERVERS_HOST_LIST} from "@/config";
import {initRegion} from "@/helpers/initApp";


export default function setup() {

    const access_token = localStorage.getItem('access-token')
    const device_uid = localStorage.getItem('device-uid')
    if (access_token && device_uid) {
        Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token
        Vue.axios.defaults.headers.common['LF-Device'] = device_uid
    } else {
        router.push({name: 'Logout'}).then()
    }

    const reg = initRegion()
    if (reg) {
        Vue.axios.defaults.baseURL = reg
    } else {
        router.push({name: 'Logout'}).then()
    }

    Vue.axios.defaults.headers.common['Content-Type'] = 'application/json'
    Vue.axios.defaults.headers.get['Content-Type'] = 'application/json'


    axios.interceptors.request.use(function (config) {

        if (config.url != SERVERS_HOST_LIST[0]+'v4/countries') {
            const reg = initRegion()
            if (reg) {
                Vue.axios.defaults.baseURL = reg
            } else {
                router.push({name: 'Logout'}).then()
            }
        }


        const token = localStorage['access-token'];
        const locale = localStorage['lang']
        if (locale) {
            config.headers.common['LF-Localization'] = locale;
        } else {
            config.headers.common['LF-Localization'] = 'ru';
        }
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            config.headers.Authorization = null;
        }

        return config;
    }, function (err) {
        return Promise.reject(err);
    });
}
axios.interceptors.response.use(function (response) {


    return response;
}, function (error) {
    // all the other error responses
    switch (error.response.status) {
        case 401: // authentication error, logout the user
            router.push({name: 'Logout'}).then(() => {
            })
            break;
        default:
            store.commit('alerts/setAlert', {
                show: true,
                messages: ['Error: ' + error.message]
            })
            console.error(error.response.status, error.message);
    }
    return Promise.reject(error);
});
